




























































import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import RateChangesModule from "@/store/modules/rate-changes";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { IPRCSetPayload, SetValuePayload } from "@/models";
import { formatDate } from "@/helpers/functions/format-date";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "CreateChange",
  components: { ApplicationLayout }
})
export default class CreateChange extends Vue {
  // ===== Store ===== //
  @rateChanges.Action("createIPRCSet") private createIPRCSet!: (payload: IPRCSetPayload) => void;
  @rateChanges.Action("setSelectedTab") private setSelectedTab!: (selectedTab: number) => void;
  @rateChanges.Action("setValue") private setValue!: (payload: SetValuePayload) => void;
  // ===== Props ===== //

  // ===== Data ===== //
  private changeDate = moment.utc().add(1, "days").toISOString().substr(0, 10);
  private changeDateMenu = false;
  private changeReason = "";
  private minDate = moment.utc().add(1, "days").toISOString().substr(0, 10);

  // ===== Methods ===== //
  private formatDate = formatDate;
  private async handleCreateIPRCSet(): Promise<void> {
    const payload: IPRCSetPayload = {
      effective_date: this.changeDate,
      description: this.changeReason
    };
    await this.createIPRCSet(payload);
    this.setSelectedTab(0);
    this.$router.push({ name: "rateChange" });
  }
  // ===== Computed ===== //
  get formattedChangeDate(): string {
    return this.formatDate(this.changeDate);
  }
  // ===== Lifecycle Hooks ===== //
}
